export default function validatePostaCode(postalCode: string) {
  if (!postalCode) {
    return false;
  }

  const re = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

  return re.test(postalCode);
}
